import classnames from "classnames";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { validateToken } from "../../actions/auth";
import { sendSupportEmail } from "../../api/ses";
import GenericDropdown from "../../containers/helpers/genericDropdown";
import { useFormFields } from "../../libs/hooksLibs";
import styles from "../../styles/UserSupport.module.scss";
import Log from "../../utils/Log";
// import selectUserTokens from "../../selectors/selectUserTokens";
import inputStyle from "../../styles/UserProfileInput.module.scss";
import { getBBVersion } from "../../utils/helperUtils";

export default function UserSupport() {
  const dropDownFields = {
    application: "",
    subject: "",
  };
  const fieldErrors = {
    application: "",
    subject: "",
    message: "",
  };
  const [fields, updateFields] = useFormFields(dropDownFields);
  const [error, setErrorObject] = useState(fieldErrors);
  const [message, setMessage] = useState("");
  // const auth = useSelector(selectUserTokens);
  const dispatch = useDispatch();

  const applicationOptions = ["Buildbox 4", "Buildbox Classic", "Buildbox 3", "Soundbox"];
  const subjectOptions = [
    "Cancel Subscription",
    "General Inquiry",
    "Payment Issue",
    "Sign In Issue",
    "Adbox",
  ];

  const handleFieldChange = (inputName, value) => {
    updateFields(inputName, value);
  };

  const handleTextAreaChange = (e) => {
    const message = e.target.value;
    setMessage(message);
  };

  const validateForm = () => {
    const values = Object.values(fields);
    const fieldsAreValid = values.every((value) => value !== "");
    const formEntries = Object.assign({ ...fields, ...{ message: message } });

    if (fieldsAreValid) {
      return true;
    }
    for (const key in formEntries) {
      if (formEntries[key] === "") {
        formEntries[key] = "Please provide a value";
      } else {
        formEntries[key] = "";
      }
    }

    setErrorObject(formEntries);
    return false;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const refreshedToken = await dispatch(validateToken());

        const body = {
          accessToken: refreshedToken,
          productType: getBBVersion(fields.application),
          subject: fields.subject,
          message: message,
        };
        await sendSupportEmail(body);
        Log.info("submitted form!", body);

        toast.success(
          "Your message was successfully sent to support@buildbox.com"
        );
      } catch (e) {
        Log.error(e, "error");
        toast.error(
          "There was a problem with sending your message. Please directly email support@buildbox.com"
        );
      }
    }
  };

  return (
    <div className={styles.userSupportWrapper}>
      <h1 className={styles.header}>Support</h1>
      <span className={styles.subheader}>
        If you have any questions, please use the form below. Our specialists
        will review your request as soon as possible and provide you with expert
        help.
      </span>
      <form className={styles.form} onSubmit={handleFormSubmit}>
        <div className={styles.dropDownContainer}>
          <div className={styles.dropdownWrapper1}>
            <GenericDropdown
              title={"Application: "}
              inputName={"application"}
              inputValue={fields.application}
              styles={{
                container: inputStyle.dropdownWrapper,
                errorMessage: inputStyle.dropdownErrorMessage,
              }}
              listItemArray={applicationOptions}
              changeCallback={handleFieldChange}
              errorMessage={error.application}
              errorMessageStyle={styles.dropdownErrorMessage}
            />
          </div>
          <div className={styles.dropdownWrapper2}>
            <GenericDropdown
              title={"Subject: "}
              inputName={"subject"}
              inputValue={fields.subject}
              styles={{
                container: inputStyle.dropdownWrapper,
                errorMessage: inputStyle.dropdownErrorMessage,
              }}
              listItemArray={subjectOptions}
              changeCallback={handleFieldChange}
              errorMessage={error.subject}
              errorMessageStyle={styles.dropdownErrorMessage}
            />
          </div>
        </div>
        <div className={styles.messageContainer}>
          <label>
            Message:
            <textarea
              name={"message"}
              placeholder="Type your message here"
              value={fields.message}
              onChange={handleTextAreaChange}
            />
          </label>
        </div>
        {error.message && (
          <div
            className={classnames(styles.dropdownErrorMessage, styles.message)}
          >
            {error.message}
          </div>
        )}
        <input
          className={styles.submitBtn}
          type="submit"
          value="Send"
          onSubmit={handleFormSubmit}
        />
      </form>
    </div>
  );
}
